import React from "react";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";

type Props = {
  canUpdateDelivery?: boolean;
  children: React.ReactNode;
};

export const MobileDeliveryActionButtons = ({ canUpdateDelivery, children }: Props) => {
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));

  if (!isMobile || !canUpdateDelivery) {
    return null;
  }

  return <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mb: 1 }}>{children}</Box>;
};
